import { createSlice } from "@reduxjs/toolkit";

const redeemSlice = createSlice({
  name: "redeem",
  initialState: {
    loading: false,
    data: null,
    error: null,
    pendingRedeemList: null,
    cancelResponse: null,
    otpResponse: null,
  },
  reducers: {
    getRedeemBalanceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getRedeemBalanceSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
    },
    getRedeemBalanceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getPendingRedeemRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.pendingRedeemList = null;
    },
    getPendingRedeemSuccess: (state, action) => {
      state.loading = false;
      state.pendingRedeemList = action.payload.data || null;
    },
    getPendingRedeemFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    cancelRedeemOrderRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.cancelResponse = null;
    },
    cancelRedeemOrderSuccess: (state, action) => {
      state.loading = false;
      state.cancelResponse = action.payload;
    },
    cancelRedeemOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createRedeemOtpRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.otpResponse = null;
    },
    createRedeemOtpSuccess: (state, action) => {
      state.loading = false;
      state.otpResponse = action.payload;
    },
    createRedeemOtpFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCancelResponse: (state) => {
      state.cancelResponse = null;
    },
  },
});

export const {
  getRedeemBalanceRequest,
  getRedeemBalanceSuccess,
  getRedeemBalanceFailure,
  getPendingRedeemRequest,
  getPendingRedeemSuccess,
  getPendingRedeemFailure,
  cancelRedeemOrderRequest,
  cancelRedeemOrderSuccess,
  cancelRedeemOrderFailure,
  createRedeemOtpRequest,
  createRedeemOtpSuccess,
  createRedeemOtpFailure,
  clearCancelResponse
} = redeemSlice.actions;

export default redeemSlice.reducer;
